import { DataModel } from "../../../../lib/data/model/DataModel.js";

export class SiteTypeModel extends DataModel {

    static _instance = null;

    static getInstance(authManager) {

        if (SiteTypeModel._instance == null) SiteTypeModel._instance = new SiteTypeModel(authManager);
        return SiteTypeModel._instance;

    }

    constructor (authManager) {

        super(authManager, 'sites/site-types', 'sites/site-types/codelist');

        this.entityName = 'sites.SiteType';
        this.privileges = {
            create: [["adminSites"]],
            read: [["adminSites"],["manageSites"],["editSites"],["readSites"]],
            update: [["adminSites"]],
            delete: [["adminSites"]],
        };

        this.label = 'Site Type';
        this.setLabel = 'Site Types';

        this.browser = {
            name: 'default-sites-sitetype-browser',
            moduleName: 'default-sites-sitetype-browser',
            moduleTitle: 'Site Types',
            moduleStateSlotName: 'default-sites-sitetype-browser',
        };

        this.editor = {
            name: 'default-sites-sitetype-editor',
            moduleName: 'default-sites-sitetype-editor',
            moduleTitle: 'Site Type',
            moduleStateSlotName: 'default-sites-sitetype-editor',
        };

        this.fieldDefs = [
            {
                name: 'id',
                type: 'int',
                persistent: true,
                label: '#ID',
                primaryKey: true,
                required: true,
                readOnly: true,
            },
            {
                name: 'code',
                type: 'string',
                persistent: true,
                label: 'Code',
                required: true,
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'name',
                type: 'string',
                persistent: true,
                label: 'Name',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'description',
                type: 'text',
                persistent: true,
                label: 'Description',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'notes',
                type: 'text',
                persistent: true,
                label: 'Notes',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'isDisabled',
                type: 'bool',
                persistent: true,
                label: 'Is Disabled',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayPosition',
                type: 'int',
                persistent: true,
                label: 'Display Position',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayLabel',
                type: 'string',
                persistent: false,
                label: 'Display Label',
                readOnly: true,
            },
            {
                name: 'displayDisabled',
                type: 'bool',
                persistent: false,
                label: 'Display Disabled',
                readOnly: true,
            },
        ];

    }

}
